var map = {
	"./1.svg": "MRlc",
	"./a1.svg": "Ti7o",
	"./a2.svg": "Z/Y8",
	"./a3.svg": "UZuy",
	"./app.svg": "CGqL",
	"./avater.svg": "loh4",
	"./b1.svg": "HYs/",
	"./badge.svg": "52Ne",
	"./bg.svg": "j7Wo",
	"./bg2.svg": "1Qfj",
	"./bg3.svg": "qfzz",
	"./c1.svg": "WZXq",
	"./c2.svg": "1Irw",
	"./c3.svg": "uibU",
	"./c4.svg": "P6GE",
	"./camp1.svg": "1M3j",
	"./cart.svg": "FkN6",
	"./cbg.svg": "l5HG",
	"./ci1.svg": "fmM7",
	"./ci2.svg": "gji4",
	"./ci3.svg": "WNVN",
	"./ci4.svg": "8y9j",
	"./close.svg": "toIl",
	"./close1.svg": "J7YS",
	"./code.svg": "IX5Q",
	"./course.svg": "4t1d",
	"./course1.svg": "4mgi",
	"./course2.svg": "46eL",
	"./cr1.svg": "4GE1",
	"./cr2.svg": "4AVd",
	"./cr3.svg": "N4qv",
	"./cr4.svg": "ONLl",
	"./cr5.svg": "8gxB",
	"./cr6.svg": "j/t6",
	"./cr7.svg": "NXsK",
	"./cr8.svg": "0Ps2",
	"./dbg.svg": "Z4Wi",
	"./edit.svg": "ql+d",
	"./ewm.svg": "+I6Z",
	"./f.svg": "ILyb",
	"./f2.svg": "6qwQ",
	"./file.svg": "fQ0v",
	"./games.svg": "b85n",
	"./gold.svg": "rtKu",
	"./jb.svg": "svV5",
	"./m1.svg": "pFrQ",
	"./m2.svg": "xNwY",
	"./m3.svg": "srq/",
	"./money.svg": "ig9B",
	"./next.svg": "H1Dn",
	"./num.svg": "blJ0",
	"./pdf.svg": "M8Oc",
	"./play.svg": "ufmG",
	"./pre.svg": "NWt6",
	"./qq.svg": "R2jY",
	"./qqgray.svg": "ZMvr",
	"./qw.svg": "0jak",
	"./r1.svg": "xnp4",
	"./r2.svg": "O3ub",
	"./r3.svg": "biMZ",
	"./r4.svg": "+iFv",
	"./r5.svg": "CsO/",
	"./r6.svg": "l6Co",
	"./rank.svg": "8L7i",
	"./rank1.svg": "zf3v",
	"./robot.svg": "ARn3",
	"./s3.svg": "ap88",
	"./sd.svg": "ymKX",
	"./star.svg": "60zo",
	"./star1.svg": "+xKG",
	"./star2.svg": "EVcW",
	"./starblue.svg": "iOGQ",
	"./theme.svg": "hdtf",
	"./tools.svg": "a3rm",
	"./u1.svg": "g0kl",
	"./u2.svg": "wBuP",
	"./u3.svg": "hCjf",
	"./u4.svg": "L/+v",
	"./u5.svg": "adPh",
	"./u6.svg": "4lBf",
	"./u7.svg": "h6/h",
	"./u8.svg": "y/Ya",
	"./u9.svg": "ot/g",
	"./user.svg": "VdD3",
	"./wave.svg": "bUWB",
	"./wave2.svg": "fLDC",
	"./wavecamp.svg": "A/fb",
	"./wb.svg": "jqT5",
	"./wbgray.svg": "xbei",
	"./web.svg": "oot7",
	"./wx.svg": "TcIh",
	"./wx1.svg": "ieP0",
	"./wxcode.svg": "03JR",
	"./wxgray.svg": "cthm",
	"./wxicon.svg": "BRHb",
	"./xx.svg": "ARbU",
	"./xz.svg": "EpEc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 0